import { Component, ViewEncapsulation, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DispatchMerge } from '@app/cp/shared/models/DispatchMerge';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { ConfirmDialogComponent } from '@app/cp/shared/components/confirm-dialog/confirm-dialog.component';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';

@UseCPLoader()
@Component({
    selector: 'merge-dispatches',
    templateUrl: './merge-dispatches.component.html',
    styleUrls: ['./merge-dispatches.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MergeDispatchesComponent
{
    compLoader: ICPLoader = this as any;
    constructor(private globals: GlobalsService, private svc_data: DispatchesService) {
        this.appCode = "MergeDispatches";
    }
    appCode: string = null;
    protected _isConstruction: boolean = false;
    @Input() set isConstruction(value: boolean) {
        if (value !== null && value !== undefined) {
            this._isConstruction = value;
            this.setValues();
        }
    }
    setValues() {
        if (this._isConstruction) {
            this.TitleDescValue = "Jobs";
            this.InlineDescValue = "job";
            this.cpSearchCodeValue = "Dispatch";
            this.cpSearchTargetCodeValue = "Job";
            this.CustomInputCodeValue = "MERGE_JOBS";
            this.SearchTextValueSource = "Search for Source Job...";
            this.SearchTextValueDest = "Search for Destination Job...";
        }
        else {
            this.TitleDescValue = "Dispatches";
            this.InlineDescValue = "dispatch";
            this.cpSearchCodeValue = "Dispatch";
            this.cpSearchTargetCodeValue = "Dispatch";
            this.CustomInputCodeValue = "MERGE_DISPATCHES";
            this.SearchTextValueSource = "Search for Source Dispatch...";
            this.SearchTextValueDest = "Search for Destination Dispatch...";
        }
    }
    TitleDescValue: string;
    InlineDescValue: string;
    CustomInputCodeValue: string;
    cpSearchCodeValue: string;
    cpSearchTargetCodeValue: string;
    SearchTextValueSource: string;
    SearchTextValueDest: string;

    get customInputValue(): string {
        let value: string = '';
        if (this.srcOrDest == "D" && CommonFunctions.hasGuidValue(this.dispatchMerge.sourceDispatchId) && CommonFunctions.hasGuidValue(this.dispatchMerge.locationId)) {
            value = this.dispatchMerge.sourceDispatchId + "," + this.dispatchMerge.locationId;
        }
        return value;
    }
    dispatchMerge: DispatchMerge = new DispatchMerge();
    customValidation() {
        return CommonFunctions.hasGuidValue(this.dispatchMerge.sourceDispatchId) && CommonFunctions.hasGuidValue(this.dispatchMerge.destDispatchId);
    }
    get destReadOnly(): boolean {
        return !CommonFunctions.hasGuidValue(this.dispatchMerge.sourceDispatchId);
    }
    ok() {
        this.svc_data.mergeDispatches(this.dispatchMerge).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.cnfShow(this.TitleDescValue + " have been successfully Merged.", CRUDActions.None, info.dcValues, "Merge " + this.TitleDescValue, "DISPATCHES_MERGED");
            }
            else {
                this.globals.notifyError("There was an error trying to merge " + this.TitleDescValue + " - " + info.message, true);
            }
        });
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.code === "DISPATCHES_MERGED") {
            this.hide();
        }
    }
    beforeActiveSet(value: boolean) {
        this.dispatchMerge = new DispatchMerge();
        this.srcOrDest = "";
    }

    search: boolean = false;
    srcOrDest: string;
    doSearch(code: string, srcOrDest: string) {
        console.log("doSearch: ", code, srcOrDest);
        if (code === "CLEAR") {
            this.setSearch(null, null);
        }
        else {
            this.srcOrDest = srcOrDest;
            this.search = true;
        }
    }
    setSearch(id: any, number: string, locationId: any = null) {
        if (this.srcOrDest === 'S') {
            this.dispatchMerge.sourceDispatchId = id;
            this.dispatchMerge.sourceDispatchNumber = number;
            this.dispatchMerge.locationId = locationId;
            console.log("dm->setSrch: ", this.srcOrDest, this.dispatchMerge, this.customInputValue, locationId);
        }
        else {
            this.dispatchMerge.destDispatchId = id;
            this.dispatchMerge.destDispatchNumber = number;
        }
    }
    searchSelected(value: any) {
        console.log("dm->selected: ", this.srcOrDest, value);
        this.search = false;
        if (value != null) {
            this.setSearch(value.DispatchId, value.DispatchNumber, value.LocationId);
        }
    }

    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();

    protected _active: boolean = false;
    set active(value: boolean) {
        this.beforeActiveSet(value);
        this._active = value;
    }
    get active(): boolean {
        return this._active;
    }

    private dirty: boolean = false;
    private get isDirty(): boolean {
        return !this.dirty;
    }
    get canSave(): boolean {
        let okToSave: boolean = false;
        if (this.isDirty) {
            okToSave = this.customValidation();
        }
        return okToSave;
    }

    show() {
        this.active = true;
    }
    private hide() {
        this.active = false;
    }

    cancel() {
        this.close();
    }

    private close(data: any = null) {
        this.closed.emit(data);
        this.hide();
    }
    private cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null) {
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code);
        }
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Delete:
                    handled = true;
                    break;
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }
    }
}
